import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& .label.blue-label': {
      color: SecondaryColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    '& .label.blue-label': {
      color: SecondaryColors.main,
    },
  },
};

const usePartnerOnlyStyles = makeStyles((muiTheme) => ({
  root: {
    '&.light-theme': lightTheme.root,
    '&.dark-theme': darkTheme.root,
    display: 'inline-flex',
    alignItems: 'baseline',
    '& .icon': {
      width: '12px',
    },
    '& .label': {
      marginLeft: muiTheme.spacing(0.7),
      lineHeight: '12px',
      fontSize: '13px',
    },
  },
}));

export default usePartnerOnlyStyles;
